module.exports = __webpack_public_path__ + "static/media/happy.6ce41296.png";